import React, { Component } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import moment from 'moment';

// icon imports
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import UpIcon from '@material-ui/icons/ArrowUpward';
import DownIcon from '@material-ui/icons/ArrowDownward';

// table imports
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

// material ui pickers
import MomentUtils from '@date-io/moment';

import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// material ui core imports
import {
  CircularProgress,
  Button,
  IconButton,
  Grid
} from '@material-ui/core';

// component imports
import {
  RegularCard,
  ItemGrid,
  CustomInput,
  Editor,
  UploadButton,
} from "../../components";

// reducer imports
import {
  loadNewsletters,
  setNewsletters,
} from './reducer/actions';

import { Redirect } from "react-router-dom";

// modal styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 20px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`
// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// custom table cell for table of news
const CustomTableCell = withStyles(theme => ({
  head: {
    textAlign: 'center'
  },
  body: {
    fontSize: 16,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '230px',
  },
}))(TableCell);

// theme styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 730,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

// Did you say weddings?
// Yes!
// Can...can we come?

// class declaration
class NewsList extends Component {

  // constructor
  constructor (props) {
    super(props);

    this.state = {
      title: '',
      subtitle: '',
      date: new Date(),
      content: '',

      showModal: false,
      isEditing: false,
      editingNews: '' // contains ID ?
    };
  }

  // when loading in, load newsletters
  componentDidMount() {
    this.props.loadNewsletters();
  }

  // on successful create/edit, close modal
  _onSuccess () {
    this.setState({ showModal: false });
  }

  // on unsuccessful create/edit, close modal and log error
  _onError (error) {
    this.setState({ showModal: false });
    console.log(error);
  }

  // set news sans deleted piece
  _onDeleteNews (id) {
    var news = this.props.allNews;
    news.splice(id, 1);
    this.props.setNewsletters(
      news,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // called when opening the Modal to Edit a piece of news
  initEditNews (id) {
    const { allNews } = this.props;
    const curNews = allNews[id];
    // get the proper piece of news to edit
    // and then set the state of the modal accordingly
    this.setState({
      title: curNews.title,
      subtitle: curNews.subtitle || '',
      date: curNews.date,
      content: curNews.content || '',
      image: curNews.image || null,
      isEditing: true,
      editingNews: id,
      showModal: true
    });
  }

  // called when the modal's Edit button is pressed
  _onEditNews (id) {
    var news = this.props.allNews;
    var obj = {
      title: this.state.title,
      subtitle: this.state.subtitle,
      date: moment(this.state.date).format(),
      image: this.state.image,
      content: this.state.content,
    };
    news[id] = obj;
    this.props.setNewsletters(
      news,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // called on pressing Create on the modal
  _onCreateNewNews () {
    var news = this.props.allNews;
    var obj = {
      title: this.state.title || '',
      subtitle: this.state.subtitle || '',
      date: this.state.date ? moment(this.state.date).format() : moment().format(),
      content: this.state.content || '',
      image: this.state.image || null,
    };
    news.push(obj);
    this.props.setNewsletters(
      news,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // on showing the modal to Create a new piece of news,
  // all the modal fields should be blank
  _onShowModal () {
    this.setState({
      title: '',
      subtitle: '',
      date: new Date(),
      content: '',
      showModal: true,
      isEditing: false,
    })
  }
  // close the modal
  _onCloseModal () {
    this.setState({ showModal: false });
  }

  // newly added functions
  // rearrange news articles upon clicking the Up button under More
  _moveNewsUp(id) {
    if (id === 0) {
      return;
    }
    let currentNews = this.props.allNews;

    let temp = currentNews[id];
    currentNews[id] = currentNews[id -1];
    currentNews[id - 1] = temp;

    this.props.setNewsletters(
      currentNews,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // same, but upon clicking Down
  _moveNewsDown(id) {
    let currentNews = this.props.allNews;
    if (id >= currentNews.length - 1) {
      return;
    }

    let temp = currentNews[id];
    currentNews[id] = currentNews[id + 1];
    currentNews[id + 1] = temp;

    this.props.setNewsletters(
      currentNews,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // render function
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'news'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('newsletters'))
    {
      return (
        <Redirect from={'news'} to={'dashboard'} key={'noTicket'} />
      );
    }

    // classes contains the Classes styles from up top
    const { classes, allNews, isLoading } = this.props;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <RegularCard
        cardTitle="Newsletters"
        cardSubtitle="News"
        content={
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {/*Top row of content descriptors */}
                <CustomTableCell>
                  #
                </CustomTableCell>
                <CustomTableCell>
                  Image
                </CustomTableCell>
                <CustomTableCell>
                  Title
                </CustomTableCell>
                <CustomTableCell>
                  SubTitle
                </CustomTableCell>
                <CustomTableCell>
                  Date
                </CustomTableCell>
                {/* <CustomTableCell>Content</CustomTableCell> */}
                <CustomTableCell>
                  More
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* If still loading,
                display an empty table with a loading swirly */}
              {isLoading &&
                <TableRow>
                  <TableCell colSpan={6}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              }
              {/* Otherwise, display rows of added News */}
              {!isLoading && !isEmpty(allNews) && allNews
                .map((n, id) => {
                  return (
                    <TableRow key={id} className={classes.row}>
                      {/* ID number field */}
                      <CustomTableCell component="th" scope="row">
                        { id + 1 }
                      </CustomTableCell>
                      {/* attached Image display field */}
                      <CustomTableCell>
                        <div
                          style={{
                            width: 100,
                            height: 40,
                            backgroundColor: '#ccc',
                            backgroundImage: `url("${n.image}")`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '50% 50%'
                          }}/>
                      </CustomTableCell>
                      {/* News title field */}
                      <CustomTableCell>
                        {n.title}
                      </CustomTableCell>
                      {/* News subtitle field */}
                      <CustomTableCell>
                        {n.subtitle}
                      </CustomTableCell>
                      {/* News post date field */}
                      <CustomTableCell>
                        {moment(n.date).format('YYYY/MM/DD')}
                      </CustomTableCell>
                      {/* Edit, Delete,
                        Move Up, and Move Down buttons */}
                      <CustomTableCell style={{display: 'flex'}}>
                        <IconButton tooltip="Edit news"
                          onClick={(e) => {this.initEditNews(id)}}>
                          <EditIcon />
                        </IconButton>
                        <IconButton tooltip="Delete news"
                          onClick={(e) => {this._onDeleteNews(id)}}>
                          <DeleteIcon />
                        </IconButton>
                        <IconButton tooltip="Move news up"
                          onClick = {(e) => {this._moveNewsUp(id)}}>
                          <UpIcon />
                        </IconButton>
                        <IconButton tooltip="Move news down"
                          onClick = {(e) => {this._moveNewsDown(id)}}>
                          <DownIcon />
                        </IconButton>
                      </CustomTableCell>
                    </TableRow>
                    );
                  }
                )
              }
              {/* after rendering all the News, display Add News button */}
              <TableRow>
                <TableCell colSpan={6}>
                  <Button style={{background: '#E5e5e5'}}
                    onClick={this._onShowModal.bind(this)}
                  >
                    Add News
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
            {/* end of page table, start of Create/Edit modal */}
            {this.state.showModal &&
              <ReactModal isOpen={this.state.showModal}
                onRequestClose={this._onCloseModal.bind(this)}
                closeTimeoutMS={450}
                contentLabel={this.state.isEditing ? 'Edit News' : 'Add News'}
                ariaHideApp={false}
                style={customModalStyles}
                >
                <ModalHeader>
                  {this.state.isEditing ? 'Edit News' : 'Add News'}
                </ModalHeader>
                <ModalContent>
                  <Grid container>
                    <ItemGrid xs={6}>
                    {/* Choose the news date */}
                      <DatePicker
                        label={'News Date'}
                        value={this.state.date}
                        onChange={(date) => {this.setState({ date: date })}} />
                    </ItemGrid>
                    <ItemGrid
                      xs={12}
                      sm={12}
                      md={6}
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex'
                      }}>
                      {/* Upload a news image */}
                      <UploadButton
                        storage="friends"
                        value={this.state.image}
                        onUploadComplete={uri => this.setState({ image: uri })}
                      />
                    </ItemGrid>
                  </Grid>
                  <Grid container>
                    <ItemGrid xs={4}>
                      {/* Set the news title */}
                      <CustomInput
                        labelText='Title'
                        id='title'
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.title,
                          onChange: (e)=>this.setState({ title: e.target.value })
                        }}
                      />
                    </ItemGrid>
                    <ItemGrid xs={8}>
                      {/* Set the news subtitle */}
                      <CustomInput
                        labelText='Sub Title'
                        id='subtitle'
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.subtitle,
                          onChange: (e)=>this.setState({ subtitle: e.target.value })
                        }}
                      />
                    </ItemGrid>
                  </Grid>
                  <Grid container>
                    <ItemGrid xs={12}>
                      {/* Set the body of the news */}
                      <Editor value={this.state.content}
                        handleChange={(html) =>
                          this.setState({ content: html})} />
                    </ItemGrid>
                  </Grid>
                </ModalContent>
                <ModalFooter>
                  {/* Confirm create/edit */}
                  <Button variant='raised'
                    primary={true}
                    onClick={(e) =>
                      {this.state.isEditing ?
                        this._onEditNews(this.state.editingNews)
                        : this._onCreateNewNews()} }>
                    {this.state.isEditing ? 'Edit' : 'Create'}
                  </Button>
                  {/* or just cancel */}
                  <Button variant='raised'
                    style={{ marginLeft: 20 }}
                    onClick={(e) =>
                      {this.setState({ isEditing: false, showModal: false })}}>
                    Cancel
                  </Button>
                </ModalFooter>
              </ReactModal>
            }
          </Table>
          }
      />
      </MuiPickersUtilsProvider>
    );
  }
} // end of class declaration

NewsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    allNews: state.newsReducer.news || [],
    isLoading: state.newsReducer.isLoading,
    user: state.authReducer.user,
    loggedIn: state.authReducer.loggedIn,
  }
};

const mapDispatchToProps = {
  loadNewsletters,
  setNewsletters,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NewsList));
